import DOMPurify from 'dompurify';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { KidsCourse } from 'types';
import {
    Announcement,
    Content,
    Description,
    Tag,
    TagBlock,
    Title,
} from '../../../courses-list/components/course-item/styled';
import {
    ButtonBlock,
    ButtonLink,
} from '../../../courses-list/components/styled';

interface IProps {
    course: KidsCourse;
}

export const CourseItem: FC<IProps> = ({ course }) => {
    const { t } = useTranslation(['common/shared', 'pages/kids-courses']);
    return (
        <Content>
            <Description>
                <TagBlock>
                    <Tag variant={'purple'}>
                        {t('pages/kids-courses:interest-2')}
                    </Tag>
                </TagBlock>
                <Title target={'_blank'} to={course.link}>
                    {course.title}
                </Title>
                <Announcement
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(course.description),
                    }}
                />
                <ButtonBlock>
                    <ButtonLink target={'_blank'} to={course.link}>
                        {t('common/shared:know-more')}
                    </ButtonLink>
                </ButtonBlock>
            </Description>
        </Content>
    );
};
